import { CloseIcon, IconFrame, InfoIcon } from '@element/icons';
import { Backdrop } from '@material-ui/core';
import PostCarePage from '@template/postCarePage';
import { formatTimeTo12Hr, formatToDateFormat, getTofixValue } from '@util/utils';
import { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';

const AppointmentDetailsModal = ({ appointment, openModal, handleClose }) => {
    const store = useSelector((state: any) => state);
    const { configData } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const languageData: any = store.languageKeywords
    const [postCarePopup, setPostCarePopup] = useState<{ open: boolean, serviceId: string, serviceName: string }>({ open: false, serviceId: '', serviceName: '' });

    const getServiceDisplayPrice = (s: any) => {
        return (s.salePrice && s.salePrice < s.billingPrice) ? s.salePrice : (s.billingPrice || s.price);
    };

    const totalAmount = (appointment?.expertAppointments || []).reduce((sum: number, ap: any) => sum + (Number(getServiceDisplayPrice(ap)) || 0), 0)

    return (
        <Fragment>
            <Backdrop
                className="backdrop-modal-wrapper"
                open={openModal ? true : false}
            >
                <div className="backdrop-modal-content" style={{ height: openModal ? 'auto' : '0px' }}>
                    <div className="heading" >{languageData["Appointment Details"] ? languageData["Appointment Details"] : "Appointment Details"}</div>
                    <div className="modal-close" onClick={handleClose}><IconFrame><CloseIcon /></IconFrame></div>
                    <div className='pricing-details-wrap order-history-wrap'>
                        <div className='heading'>
                            {Boolean(appointment?.invoiceId) && <div className='order-id'>{languageData["Invoice No"] ? languageData["Invoice No"] : "Invoice No"}: {appointment?.invoiceId}</div>}
                            <div>
                                <span className="right-align">
                                    Date: {formatToDateFormat(appointment.appointmentDay, configData.dateFormat)} {formatTimeTo12Hr(appointment.appointmentTime)}
                                </span>
                            </div>
                        </div>

                        <div className='heading'>{languageData["Services"] ? languageData["Services"] : "Services"}</div>
                        {(appointment?.expertAppointments || []).map((s: any, idx: number) => (
                            <div className='service-item' key={idx}>
                                <div>
                                    <div
                                        className="service-name-wrap"
                                        style={{
                                            cursor: s.serviceId ? 'pointer' : 'default',
                                            color: s.serviceId ? '#3f51b5' : 'inherit',
                                            fontWeight: 500
                                        }}
                                        onClick={(e) => {
                                            if (s.serviceId) {
                                                e.stopPropagation();
                                                setPostCarePopup({ open: true, serviceId: s.serviceId, serviceName: s.service });
                                            }
                                        }}
                                    >
                                        <span>{s.serviceCategory} - {s.service}</span>
                                        {(s.serviceId && configData?.storeConfig?.basicConfig?.postCare) && (
                                            <span title="Click to view Post Care" style={{ display: 'flex' }}>
                                                <InfoIcon style={{ fontSize: '14px', color: '#3f51b5' }} />
                                            </span>
                                        )}
                                    </div>
                                    {Boolean(s.expertName) && <div className='order-type'>{s.expertName}</div>}
                                </div>
                                <div className='right-align'>{configData.currencySymbol} {getTofixValue(getServiceDisplayPrice(s))}</div>
                            </div>
                        ))}
                        <span className="right-align">Total: {configData.currencySymbol} {getTofixValue(totalAmount)}</span>
                    </div>
                </div>
            </Backdrop>

            <Backdrop className="backdrop-modal-wrapper ordrer-backdrop-modal-wrapper" open={postCarePopup.open} style={{ zIndex: 1400 }}>
                {postCarePopup.open && (
                    <div className="backdrop-modal-content" style={{ height: '100vh' }}>
                        <div className="heading">Post-Care - {postCarePopup.serviceName}</div>
                        <div className="modal-close" onClick={() => setPostCarePopup({ open: false, serviceId: '', serviceName: '' })}>
                            <IconFrame><CloseIcon /></IconFrame>
                        </div>
                        <div className="pricing-details-wrap" style={{ height: 'calc(100vh - 60px)', overflowY: 'auto' }}>
                            <PostCarePage isPopup={true} propServiceId={postCarePopup.serviceId} propServiceName={postCarePopup.serviceName} onClose={() => setPostCarePopup({ open: false, serviceId: '', serviceName: '' })} />
                        </div>
                    </div>
                )}
            </Backdrop>
        </Fragment>
    )
}

export default AppointmentDetailsModal